module.exports = "var orderItems = {{transactionProducts}} || [];\nfor (var i = 0; i < orderItems.length; i++) {\n  var orderItem = orderItems[i];\n  orderData.order.products.push({\n    id: orderItem.sku,\n    name: orderItem.name,\n    category: orderItem.category,\n    price: orderItem.price,\n    quantity: orderItem.quantity\n  });\n}\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/Wizard/Snippet/snippets/transactionProductsBlock.html
// module id = 2161
// module chunks = 0